import { FC } from 'react';
import styled from 'styled-components';

import SvgIcon from './SvgIcon';

const BigGreenCheckIcon = styled(SvgIcon).attrs({ name: 'iconCheckFancy', width: '128px' })`
  color: ${({ theme }) => theme.baseBlue.a10};
  text-align: center;
`;

const HappyText = styled.span``;

const flexCenter = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexFlow: 'column',
};

export const LinkedTile = styled.a(flexCenter);

export const NonLinkedTile = styled.div(flexCenter);

interface OwnProps {
  text: string;
  linkTo?: string;
}

const BigSuccess: FC<OwnProps> = props => {
  const iconAndText = (
    <>
      <BigGreenCheckIcon />
      <HappyText>{props.text}</HappyText>
    </>
  );
  return props.linkTo ? (
    <LinkedTile href={props.linkTo}>{iconAndText}</LinkedTile>
  ) : (
    <NonLinkedTile>{iconAndText}</NonLinkedTile>
  );
};

export default BigSuccess;
